import axios from "axios";

export const state = {
    stocklevels: [],
};

export const getters = {
    stocklevels: state => state.stocklevels,
};

export const mutations = {
    setStock(state, newValue) {
        state.stocklevels = newValue
    },
};

export const actions = {
    fetchStocklevels({ commit }) {
        axios.get('/productitemunits').then(res => {
            commit('setStock', res.data.itemunits);
        })
    },
};
